// Basado en el Analizador Cabrillo original de XQ2OP.
// Tablas estáticas puras, extraídas sin cambios del bloque
// //PURE-START..//PURE-END de public/cabrillo/src/plantilla.html.
// Ver src/cabrillo/CREDITOS.md.

export const CONT = ['NA', 'EU', 'AS', 'SA', 'OC', 'AF', 'AN'];

export const CNAME = {
    NA: 'Norteamérica',
    EU: 'Europa',
    AS: 'Asia',
    SA: 'Sudamérica',
    OC: 'Oceanía',
    AF: 'África',
    AN: 'Antártida',
};

export const CL = {
    NA: '#378add',
    EU: '#e0913a',
    AS: '#d4537e',
    SA: '#1d9e75',
    OC: '#7f77dd',
    AF: '#a8a49a',
    AN: '#5f5e5a',
};

export const BCOL = [
    '#e24b4a', '#ef9f27', '#1d9e75', '#378add', '#7f77dd',
    '#d4537e', '#639922', '#888780', '#993c1d', '#0f6e56',
];

// [frecuenciaMinKHz, frecuenciaMaxKHz, nombreBanda]
export const BR = [
    [1800, 2000, '160'],
    [3500, 4000, '80'],
    [5250, 5450, '60'],
    [7000, 7300, '40'],
    [10100, 10150, '30'],
    [14000, 14350, '20'],
    [18068, 18168, '17'],
    [21000, 21450, '15'],
    [24890, 24990, '12'],
    [28000, 29700, '10'],
    [50000, 54000, '6'],
    [144000, 148000, '2'],
    [420000, 450000, '70cm'],
];
